<template>
  <div class="mx-3">
    <b-form @submit="onSubmit" @reset="onReset">
      <h4>Edit project details</h4>
      <b-row
        ><b-col md="6">
          <b-form-group
            id="edit-project-status-select"
            label="Select project
            status"
            label-for="project-status-select"
          >
            <b-form-select
              id="project-status-select"
              v-model="projectDetails.status"
              :options="statusOptions"
              value-field="text"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="edit-target-launch-semester-select"
            label="Select
            target launch semester"
            label-for="target-launch-semester-select"
          >
            <b-form-select
              id="target-launch-semester-select"
              v-model="projectDetails.target_launch_semester"
              value-field="text"
              :options="semesters"
            ></b-form-select>
          </b-form-group> </b-col
      ></b-row>
      <b-row
        ><b-col md="6">
          <b-form-group
            id="edit-delivery-date"
            label="Enter a delivery date"
            label-for="delivery-date-input"
          >
            <b-form-input
              id="delivery-date-input"
              type="date"
              v-model="projectDetails.delivery_date"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          ><b-form-group
            id="additional-comments-textbox"
            label="Optional comment
            (will be added to log)"
            label-for="additional-comments-input"
          >
            <b-form-textarea
              id="additional-comments-input"
              rows="3"
              v-model="projectDetails.additional_comments"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-button class="mx-3" type="reset" variant="secondary">Reset</b-button>
        <b-button class="mx-3" type="submit" variant="primary">Submit</b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  export default {
    name: 'GProjectDetailsForm',
    data() {
      return {
        projectDetails: {
          status: this.projectStatus,
          delivery_date: this.deliveryDate,
          target_launch_semester: this.targetLaunchSemester,
          additional_comments: ''
        }
      }
    },
    methods: {
      // TODO: call createComment after running the updates.
      async onSubmit(evt) {
        evt.preventDefault()
        this.projectDetails['updater'] = this.currentUser.full_name
        this.projectDetails['updater_id'] = this.currentUser.id
        this.projectDetails['project_id'] = this.currentProject.id
        if (this.projectDetails.additional_comments !== '') {
          this.projectDetails.additional_comments = `---\n${this.projectDetails.additional_comments}`
        }
        try {
          if (this.projectStatus !== this.projectDetails.status) {
            this.projectDetails.additional_comments = `∙ Status changed: ${this.projectStatus} → ${this.projectDetails.status} \n${this.projectDetails.additional_comments}`
            await this.$store.dispatch(
              'updateProjectStatus',
              this.projectDetails
            )
          }
          if (this.deliveryDate !== this.projectDetails.delivery_date) {
            this.projectDetails.additional_comments = `∙ Delivery date changed: ${this.deliveryDate} → ${this.projectDetails.delivery_date} \n${this.projectDetails.additional_comments}`
            await this.$store.dispatch(
              'updateProjectDeliveryDate',
              this.projectDetails
            )
          }
          if (
            this.targetLaunchSemester !==
            this.projectDetails.target_launch_semester
          ) {
            this.projectDetails.additional_comments = `∙ Target launch semester changed: ${this.targetLaunchSemester} → ${this.projectDetails.target_launch_semester} \n${this.projectDetails.additional_comments}`
            await this.$store.dispatch(
              'updateProjectTargetLaunchSemester',
              this.projectDetails
            )
          }
          let today = new Date()
          await this.$store.dispatch('createComment', {
            project_id: this.projectDetails.project_id,
            author_id: this.projectDetails.updater_id,
            content: this.projectDetails.additional_comments,
            created_date: today.toISOString().substring(0, 10)
          })
          await this.$store.dispatch('getProjects')
          await this.$store.dispatch('toggleCommentForm')
          this.$root.$bvToast.toast(
            `Project details updated and changes logged.`,
            {
              title: 'Success',
              autoHideDelay: 1000,
              toaster: 'b-toaster-top-center',
              variant: 'success'
            }
          )
        } catch (err) {
          console.error(err)
          this.$root.$bvToast.toast(`${err}`, {
            title: 'Unsuccessful',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          })
        }
        this.projectDetails = {
          status: this.projectStatus,
          delivery_date: this.deliveryDate,
          target_launch_semester: this.targetLaunchSemester,
          additional_comments: ''
        }
      },
      onReset(evt) {
        evt.preventDefault()
        this.projectDetails = {
          status: this.projectStatus,
          delivery_date: this.deliveryDate,
          target_launch_semester: this.targetLaunchSemester,
          additional_comments: ''
        }
      }
    },
    computed: {
      currentProject() {
        return this.$store.getters.currentProject
      },
      currentUser() {
        return this.$store.getters.currentUser
      },
      statusOptions() {
        return this.$store.state.courseDev.ui.projectStatusOptions
      },
      semesters() {
        return this.$store.state.courseDev.ui.projectSemesterOptions
      }
    },
    props: {
      deliveryDate: String,
      projectStatus: String,
      targetLaunchSemester: String
    }
  }
</script>
